function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M16.508 0c-1.951 0-4.052.385-5.503 1.442C9.555.385 7.453 0 5.503 0 4.052 0 2.51.211 1.22.76.49 1.076 0 1.76 0 2.537V13.38c0 1.25 1.22 2.172 2.481 1.864.98-.24 2.021-.346 3.022-.346 1.56 0 3.221.25 4.562.885.6.288 1.28.288 1.87 0 1.341-.644 3.002-.885 4.562-.885 1.001 0 2.041.106 3.022.346 1.26.318 2.481-.605 2.481-1.864V2.538c0-.779-.49-1.461-1.22-1.779C19.498.211 17.957 0 16.507 0zm3.501 12.237c0 .605-.58 1.047-1.2.942-.75-.135-1.531-.193-2.301-.193-1.701 0-4.152.625-5.503 1.442V3.364c1.35-.817 3.802-1.442 5.503-1.442.92 0 1.83.087 2.7.27.46.096.801.49.801.942v9.103z"
});

var SvgIcoContacts = function SvgIcoContacts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-contacts.fff00c7f.svg";
export { ForwardRef as ReactComponent };